"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findCultureSettings = findCultureSettings;
/**
 * Finds the culture setting in the array of {@link cultures tenant culture settings} for the specified {@link search language}.
 * @param cultures The array of tenant culture settings
 * @param search The value to be searched for in the {@link cultures}
 * @returns An object containing culture settings
 */
function findCultureSettings(cultures, search) {
  if (!cultures || !search) {
    return undefined;
  }
  return cultures.find(({
    cultureCode
  }) => cultureCode === search);
}
//# sourceMappingURL=findCultureSettings.js.map